export default {
    data() {
        return {
            download: this.baseUrl + 'zip/file.zip',
            //上传的文件
            fileListExcel: [],
            //上传文件的接口
            address: this.baseUrl + 'file/import_products?token=' + this.$store.state.id,
            action: this.baseUrl + 'file/upload_img?token=' + this.$store.state.id,
            creatFlag: '0',
            image_data: '',//图片唯一名
            form: {
                attr: '',
                cer_industry: null,
                cer_year: '',
                desc: '',
                id: '',
                image: '',
                is_auth: '',
                name: '',
                onsale: '',
                period: '',
                price: '',
                project_id: '',
                shop_name: '',
                teacher: '',
                teacher_intro: '',
                page: '',
                label_name: '',
                label_id: '',
            },
            //显示的价格
            price1: '',
            product_lablel_id: '',//产品标签连接表 id
            formCascader: [],
            formCascader1: [],
            //那一项数据
            flag: '',
            formLabelWidth: '120px',
            tableData: [{
                label_name: '',
            }],
            dialogFormVisible: false,
            multipleSelection: [],
            pages: [{
                value: '选项1',
                label: '课程云超市'
            },
                //  {
                // value: '选项2',
                // label: '项目式'
                // }
            ],
            classType: [{
                value: '选项1',
                label: '专业课'
            }, {
                value: '选项2',
                label: '选修课'
            }],
            classCertification: [{
                value: '1',
                label: '已认证'
            }, {
                value: '0',
                label: '未认证'
            }],
            totalProduct: 1,
            productLen: '15',
            offset: 0,
            currentPage: 1,
            totalPage: '',
            search: '',
            fileList: [{ name: '', url: '' }],
            //图片上传
            dialogImageUrl: '',
            dialogVisible: false,
            dialogFormRead: false,
            //标签
            labels: [
                {
                    id: '0',
                    name: '',
                    children: [

                    ]
                },
            ],

            labelsMap: [],
            props: {
                label: 'name',
                children: 'children',
                value: 'id'
            },
            selectedOptions: [],
            //任务
            tasks: [],
            tasksFormSel: '',
            tasksInf: {},
            taskId: '',
            //筛选条件
            shelves: [{
                value: '0',
                label: '未上架'
            }, {
                value: '1',
                label: '已上架'
            }],
            certification: [{
                value: '0',
                label: '未认证'
            }, {
                value: '1',
                label: '已认证'
            }],
            attr: [{
                value: '选修课',
                label: '选修课'
            }, {
                value: '专业课',
                label: '专业课'
            }],
            cer_annual: [{
                value: '',
                label: '全年度',
            }],
            checkList: {
                onsale: '',
                is_auth: '',
                cer_year: '',
                teacher: '',
                name: '',
                attr: '',
            },

            //项目式 数据
            itemList: [],
            itemOptions: [],
            itemCheck: {},

            pickerOptions1: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },

            },
            value1: '',
            optionDate: '',
            fullscreenLoading: false
        }
    },
    methods: {
        // 点击上传课程
        httpreq(q) {
            // // console.log(q);
            let action = "";
            if (this.$store.state.store.id == "5") {
                action = 'http://gxjs.ca163.net/file/import_products?token=' + this.$store.state.id;
            } else {
                action = this.address;
            }

            this.$upload(action, q).then(res => {
                this.$alert(res.data.result.msg, '提示', {
                    confirmButtonText: '确定',
                });
            })
        },
        //上传图片
        httpreq1(q) {
            this.$upload(this.action, q).then(res => {
                this.image_data = res.data.result;
            })

        },
        //批量下架
        batchPutaway() {
            // // console.log(this.multipleSelection.length)
            // 判断已勾选数组是否为空
            if (this.multipleSelection.length !== 0) {
                // 储存已勾选的id
                let multipleSelectionID = [];
                for (var n = 0; n < this.multipleSelection.length; n++) {
                    multipleSelectionID[n] = JSON.parse(this.multipleSelection[n].id);
                    // // console.log(this.multipleSelection[n].id)
                }
                this.multipleSelection = []
                // // console.log(multipleSelectionID)
                // js对象转json数据
                let last = JSON.stringify(multipleSelectionID)
                // // console.log(last)
                // onsale为0代表下架商品
                this.$post('products/set_many_onsale', { token: this.$store.state.authority_management, onsale: 0, id_arr: last }).then(res => {
                    // // console.log(res.data.status)
                    if (res.data.status = 'success') {
                        this.$message({
                            message: '下架成功',
                            type: 'success'
                        });
                    }
                    // 重新加载数据
                    this.getData();
                })
            } else {
                this.$message({
                    message: '请勾选产品',
                    type: 'warning'
                });
            }

        },
        //批量上架
        batchSoldout() {
            // 判断已勾选数组是否为空
            if (this.multipleSelection.length !== 0) {
                // 储存已勾选的id
                let multipleSelectionID = [];
                for (var n = 0; n < this.multipleSelection.length; n++) {
                    multipleSelectionID[n] = JSON.parse(this.multipleSelection[n].id);
                }
                this.multipleSelection = []
                // js对象转json数据
                let last = JSON.stringify(multipleSelectionID)
                // onsale为1代表上架商品
                this.$post('products/set_many_onsale', { token: this.$store.state.authority_management, onsale: 1, id_arr: last }).then(res => {
                    // // console.log(res)
                    if (res.data.status = 'success') {
                        this.$message({
                            message: '上架成功',
                            type: 'success'
                        });
                    }
                    // 重新加载数据
                    this.getData();
                })
            } else {
                this.$message({
                    message: '请勾选产品',
                    type: 'warning'
                });
            }

        },
        //预览课程
        previewClass(obj) {
            // // console.log(obj.project_id)


        },
        //上传文件的几个方法
        beforeUpload(file) {
            let str = file.name;
            // // console.log(file);
            if (str.substr(str.length - 3, 3).toLocaleLowerCase() != "zip") {
                alert('压缩文件必须是zip格式')
                return false;
            }
        },
        beforeUpload2(file) {
            // // console.log(file);
            const isImage = file.name.replace(/.+\./, "");
            if (['jpg', 'jpeg', 'png', 'JPG', 'JPEG'].indexOf(isImage) == '-1') {
                // // console.log('进入判断')
                this.$message({
                    showClose: true,
                    message: '上传文件类型错误！',
                    type: 'warning'
                })
                return false
            }
        },
        handleRemove(file, fileList) {
            // // console.log(file, fileList);
        },
        handlePreview(file) {
            // // console.log(file);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        isOk(response, file, fileList) {
            alert(response.result.msg);
        },
        //获取当前年份
        getYear() {
            let mydate = new Date();
            let year = mydate.getFullYear();
            for (let i = year; i >= 2018; i--) {
                this.cer_annual.push({ value: i, label: i })
            }
        },
        //获取标签
        getLabel() {
            this.$post('labels/all', { shop_id: this.$store.state.store.id }).then(res => {
                let data = res.data.result;
                this.labelsMap = res.data.result;
                this.allLabel(data, this.labels[0]);
            })
        },
        //获取数据
        getData() {
            this.fullscreenLoading = true
            this.$post('products/shop_search', { offset: this.offset, length: this.productLen, token: this.$store.state.authority_management, is_project: 1, shop_id: this.$store.state.store.id }).then(res => {
                // // console.log(res.data.result.data)
                this.tableData = res.data.result.data;
                // // console.log('data',this.tableData)
                this.totalProduct = res.data.result.total;
                this.totalPage = Math.ceil(this.totalProduct / this.productLen);
                this.fullscreenLoading = false
                // // console.log(this.totalPage)
            })
        },
        //项目
        getTask() {
            this.$post('activities/search', { offset: 0, length: 9999, token: this.$store.state.authority_management }).then(res => {
                this.tasks = res.data.result.data;
                // console.log(res.data.result.data)
            })
        },
        tasksFormSelChange() {
            // // console.log(this.tasksFormSel)
            for (let i of this.tasks) {
                // // console.log('每一个活动');
                // // console.log(i);
                // // console.log('========');

                if (i.id == this.tasksFormSel) {
                    this.tasksInf = i;
                    // // console.log(this.tasksInf)
                }
            }
        },
        allLabel(data, labelObj) {
            // // console.log(data,labelObj)
            for (let i in data) {
                // // console.log('label')
                // // console.log(labelObj.id)
                if (data[i].parent_id === labelObj.id) {
                    if (!labelObj.children) {
                        labelObj.children = [];
                    }
                    labelObj.children.push(data[i]);
                    // // console.log(Object.prototype.toString.call(this.labels[0].children),this.labels[0].children)
                    this.allLabel(data, data[i]);
                }
            }
        },
        //标签选择

        handleChange1(value, form) {
            this.formCascader = value;
            let id = value.pop();
            this.formCascader.push(id);
            // // console.log('id',this.formCascader)
            //获取父类id
            return false
            this.$post('labels/get_patients', { label_id: id, }).then(res => {
            })
        },
        //搜索栏标签选择
        handleChange2(value, form) {
            this.formCascader1 = value;

            let id = value.pop();
            this.formCascader1 = id
            // // console.log('id',id)
            //获取父类id
            return false
            // this.$post('labels/get_patients', { label_id: id, }).then(res => {
            // })
        },

        handleSizeChange(val) {
            // // console.log(`每页 ${val} 条`);
            this.productLen = val;
            this.getData();
        },
        handleCurrentChange(val) {
            // // console.log(`当前页: ${val}`);
            this.offset = (val - 1) * this.productLen;
            this.getData();
        },
        selectType(item, index) {//选择课程类型

            this.tableData[index].attr = item.label;
        },
        selectItemFrom(item) {
            this.form.project_id = item.value
        },
        selectTypeFrom(item) {
            this.form.attr = item.label
        },
        selectPage(item, index) {//选择课程页面

            this.tableData[index].page = item.label;

        },
        selectPageFrom(item) {
            this.form.page = item.label;


        },
        selectCert(item, index) {//选择是否认证
            this.tableData[index].is_auth = item.label;
        },
        selectCertForm() {
        },
        selectCerYear(item, index) {
            this.tableData[index].cer_year = item.label;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            // // console.log(val)
        },
        handleCancle(index, row) {  //取消

            let prevContent = this.prevValue.bookname;
            this.$set(row, "bookname", prevContent);
        },
        addLine(f) { //添加行数
            this.form = {};
            this.creatFlag = f;
            this.dialogFormVisible = true;
        },
        //删除
        handleDelete(index, row) {
            // // console.log(index,row)
            this.$confirm('此操作将删除该活动, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post('products/shop_delete', { token: this.$store.state.authority_management, id: row.id })
                this.tableData.splice(index, 1);
                this.getData();
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        //上下架
        changeOnsale(index, row, flag) {
            if (flag == 1) {
                row.onsale = 1;
                this.multipleSelection = []
                this.multipleSelection.push(row)
                this.batchSoldout()
                // this.upProduct(index, row);
            }
            else if (flag == 0) {
                row.onsale = 0;
                this.multipleSelection = []
                this.multipleSelection.push(row)
                this.batchPutaway()
                // this.upProduct(index, row);
            }

        },
        //保存
        // save(index,row){
        //   // console.log(row)
        //   // // console.log(JSON.stringify(this.tableData))
        //   this.tableData[index] = row;
        //   // console.log(this.tableData[index])
        //   this.addProduct(index,row)
        // },
        selectRow(val) {
            this.multipleSelection = val;
        },
        //条件查询数据
        searchData() {
            // // console.log(this.optionDate)
            // 搜索时间的转换
            var d = new Date(this.optionDate);
            let year = d.getFullYear(),
                month = d.getMonth() + 1 >= 10 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1),
                day = d.getDate() >= 10 ? d.getDate() : '0' + d.getDate();
            let time = year + '-' + month + '-' + day;
            if (time == 'NaN-0NaN-0NaN') {
                time = ''
            }
            // // console.log(time)
            this.$post('products/shop_search', {
                token: this.$store.state.authority_management,
                offset: 0,
                length: this.productLen,
                name: this.checkList.name,
                teacher: this.checkList.teacher,
                onsale: this.checkList.onsale,
                is_auth: this.checkList.is_auth,
                cer_year: this.checkList.cer_year,
                attr: this.checkList.attr,
                created_at: time,
                label_id: this.formCascader1,
                shop_id: this.$store.state.store.id
            }).then(res => {
                // // console.log(res.data.result.data)

                this.tableData = res.data.result.data;
                // // console.log('data1',this.tableData)
                this.totalProduct = res.data.result.total;
            })

            // // console.log(this.checkList)
        },
        //清除条件
        clearCheckList() {
            this.checkList = { onsale: '', is_auth: '', cer_year: '', teacher: '', name: '', };
            this.getData();
        },
        //模糊查询
        batchDelete() {
            // // console.log(11)
            // // console.log(this.multipleSelection)
            for (let i = 0; i < this.multipleSelection.length; i++) {
                let val = this.multipleSelection[i]
                // // console.log(val)
                for (let j = 0; j < this.tableData.length; j++) {
                    let val1 = this.tableData[j];
                    if (val == val1) {
                        this.tableData.splice(j, 1);
                        // // console.log(this.tableData)
                        break;
                    }
                }

            }
            // 删除完数据之后清除勾选框

        },
        //更新产品
        upProduct(index, val) {
            if (!this.taskId) return false
            else {
                // // console.log('1111111');
                // // console.log(val.price);
                this.$post('products/edit', {
                    name: val.name,
                    desc: val.desc,
                    image: this.image_data,
                    price: val.price,
                    project_id: val.project_id,
                    period: val.period,
                    teacher: val.teacher,
                    teacher_intro: val.teacher_intro,
                    onsale: val.onsale,
                    is_auth: val.is_auth,
                    attr: val.attr,
                    cer_year: val.cer_year,
                    cer_industry: val.cer_industry,
                    id: val.id,
                    label_id: val.label_id,
                    label_name: val.label_name,
                    token: this.$store.state.authority_management,
                });
            }

            this.$post('product_labels/edit', { token: this.$store.state.authority_management, label_id: val.label_id, id: this.product_lablel_id, }).then(res => {
                // // console.log('')
                this.$message({
                    showClose: true,
                    message: '成功更新产品',
                    type: 'success'
                });
                this.getData();
            });
            this.$post('task_activities/update', { token: this.$store.state.authority_management, task_id: this.taskId, activity_id: this.tasksFormSel }).then(res => {
            })
        },
        //增加产品
        addProduct(index, val) {
            //插入图片
            this.$post('resources/shop_create', { token: this.$store.state.authority_management, name: val.image, data: this.image_data, type: '5' }).then(res => {
            })
            this.$post('products/create', {
                name: val.name,
                desc: val.desc,
                image: this.image_data,
                price: val.price,
                project_id: val.project_id,
                period: val.period,
                teacher: val.teacher,
                teacher_intro: val.teacher_intro,
                onsale: val.onsale,
                is_auth: val.is_auth.value ? val.is_auth.value : '0',
                attr: val.attr,
                cer_year: val.cer_year,
                cer_industry: val.cer_industry,
                shop_id: this.$store.state.store.id,
                id: val.id,
                label_id: val.label_id,
                token: this.$store.state.authority_management,
                activity_id: this.tasksFormSel
            }).then(res => {
                this.$message({
                    showClose: true,
                    message: '成功增加产品',
                    type: 'success'
                });
                this.dialogTableVisible = false;
                this.getData();
            });
        },
        handleEdit1(index, row) {
            this.form = row;
            // // console.log('价格');
            // // console.log(typeof(this.form.price));
            // let num = this.form.price;
            // num = num.toFixed(2);//将数字转成带有2位小数的字符串

            // num = parseFloat(num)//将带有2位小数的字符串转成带有小数的数字
            let num1 = this.form.price;
            num1 = parseFloat(num1);

            num1 = num1.toLocaleString();//将带有2位小数的数字转成金额格式  
            this.price1 = num1;
            // // console.log(num1);
            this.flag = index;
            this.creatFlag = 0;
            this.selectProTask(row.id);

            for (let i of this.labelsMap) {
                if (row.label_id == i.id) {
                    if (this.formCascader.indexOf(i.id) == -1) {
                        this.formCascader.push(i.id)

                    }
                    if (i.parent_id != 0) {
                        this.formCascader.unshift(i.parent_id)
                    }
                    i = i.parent_id
                }
            }
            this.$post('product_labels/listLabels', { offset: 0, length: 1, product_id: row.id }).then(res => {
                // // console.log(res.data.result.data[0].id)
                this.product_lablel_id = res.data.result.data[0].id;
            })
            this.dialogFormVisible = true;
        },
        selectProTask(proId) {
            this.$post('products/get_task_by_product_id', { token: this.$store.state.authority_management, id: proId, length: 999, offset: 0 }).then(res => {
                //返回的整个任务，任务里面包含着活动
                this.tasksInf = res.data.result.data[0];
                //活动的id
                this.tasksFormSel = this.tasksInf.activitie_id;
                //任务id
                this.taskId = this.tasksInf.task_id;
            })
        },
        handleDesc(index, row) {
            this.form = row;
            this.selectProTask(row.id);
            this.dialogFormRead = true;
        },

        handleRemove(file, fileList) {
            // // console.log(file, fileList);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 上传成功之后 插入图片名字
        handleAvatarSuccess(res, file) {//图片上传成功
            // // console.log(res);
            // // console.log(file);
            this.imageUrl = URL.createObjectURL(file.raw);
            //         {status: "success", result: "2019-05-17-01-24-18.jpg"} 拿到返回的图片名字=》
            // // console.log(res.result);
            // // console.log(this.dialogImageUrl);


        },
        handleSuccess(response, file, fileList) {
            // // console.log('图片上传成功')
            this.image_data = response.result;
            alert(this.image_data)
            // this.form.image = response.result;      

        },
        closeDialog() {
            this.formCascader = [];
            this.form = {};
        },
        onSubmit() {
            let value = this.form;
            if (value.name == '' || value.name == undefined) {
                this.$message({
                    showClose: true,
                    message: '产品名称不为空',
                    type: 'error'
                });
                return false
            }
            else if (value.desc == '' || value.desc == undefined) {
                this.$message({
                    showClose: true,
                    message: '产品详情不为空',
                    type: 'error'
                });
                return false
            }
            else if (value.price == '' || value.price == undefined) {
                this.$message({
                    showClose: true,
                    message: '产品价格不为空',
                    type: 'error'
                });
                return false
            }
            else if (value.teacher == '' || value.teacher == undefined) {
                this.$message({
                    showClose: true,
                    message: '主讲名字不为空',
                    type: 'error'
                });
                return false
            }
            else if (value.price == '' || value.price == undefined) {
                this.$message({
                    showClose: true,
                    message: '价格不为空',
                    type: 'error'
                });
                return false
            }
            else if (!/^[0-9]+(.[0-9]{2})?$/.test(value.price)) {
                this.$message({
                    showClose: true,
                    message: '价格只能为正实数',
                    type: 'error'
                });
                return false
            }
            else if (value.is_auth == '' || value.is_auth == undefined) {
                this.$message({
                    showClose: true,
                    message: '认证状态不为空',
                    type: 'error'
                });
                return false
            }
            else if (value.period == '' || value.period == undefined) {
                this.$message({
                    showClose: true,
                    message: '学时不为空',
                    type: 'error'
                });
                return false
            }

            else if (!/^\+?[1-9][0-9]*$/.test(value.period)) {
                this.$message({
                    showClose: true,
                    message: '学时只能为正整数',
                    type: 'error'
                });
                return false
            }
            else {
                let id = this.formCascader[this.formCascader.length - 1];
                for (let i of this.labelsMap) {
                    if (id == i.id) {
                        this.form.label_name = i.name;
                        this.form.label_id = i.id;
                    }
                }
                if (this.creatFlag == 1) {
                    //调用添加产品的方法
                    this.addProduct(this.flag, this.form)
                } else {
                    //调用更新产品的方法
                    this.upProduct(this.flag, this.form);
                }
                this.dialogFormVisible = false;
            }

        },


    },
    created: function () {
        //获取数据
        this.getData();
        //获取标签
        this.getLabel();
        //获取当前年份
        this.getYear();
        //项目
        this.getTask();
    }
}
